import React from 'react';
import { I18n } from 'react-redux-i18n';

import { I18N_BASE } from '../../constants';
import { ModerationEvent, EventSnapshot } from '../../models';
import CategoryChip from '../../components/CategoryChip/CategoryChip';
import ScorePill from '../../components/ScorePill/ScorePill';
import styles from './review.module.css';

export interface AiSignalStripProps {
  event: ModerationEvent;
  snapshot: EventSnapshot;
  testId?: string;
}

function formatConfidence(confidence: number): string {
  return `${Math.round(confidence * 100)}%`;
}

export function AiSignalStrip({
  event,
  snapshot,
  testId,
}: AiSignalStripProps): React.ReactElement {
  return (
    <section className={styles.signalStrip} data-testid={testId}>
      <div className={styles.signalScore}>
        <ScorePill score={event.aiScore} testId="signal-score" />
      </div>
      <div className={styles.signalDetails}>
        <div className={styles.signalMeta}>
          <CategoryChip category={event.aiCategory} />
          <span>
            {I18n.t(`${I18N_BASE}.detail.aiSignal.confidence`, {
              confidence: formatConfidence(event.aiConfidence),
            })}
          </span>
          {event.aiPromptVersion ? (
            <span className={styles.signalFootnote}>
              {I18n.t(`${I18N_BASE}.detail.aiSignal.promptVersion`, {
                version: event.aiPromptVersion,
              })}
            </span>
          ) : null}
        </div>
        {snapshot.aiReasoning ? (
          <p className={styles.signalReasoning}>{snapshot.aiReasoning}</p>
        ) : null}
      </div>
    </section>
  );
}

export default AiSignalStrip;
